import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import {
  useTransportControllers,
  useBalance,
  useAuth,
  useCountryInfo,
} from 'react-render-hooks';
import cln from 'classnames';
import {
  Banners,
  useZustandLanguagesKitStore,
  languageSelectors,
  useTranslate,
  useZustandModalKitStore,
  zustandModalKitSelector,
  EModalTypes,
} from 'react-gldn-kit';
import {
  AuthInfo,
  CountryInfo,
} from 'react-memory-optimization/dist/lib/store/user/types';
import { ECasinoCategoryIds } from 'react-memory-optimization/dist/lib/store/casino/entities/categories/types';
import { BalanceInfo } from 'react-memory-optimization/dist/lib/store/user/entities/balance/types';

import HomeCategories from './components/HomeCategories';
import CasinoCategories from 'components/CasinoComponents/CasinoCategories';

import { APP_TYPE } from 'constants/ui';

import { useZustandDeviceStore } from 'stores/device/store';
import { isMobileDeviceSelector } from 'stores/device/selectors';

import { EBannerTypes } from './types';

import { useHookFabric } from 'hooks/useHookFabric';

import styles from './Home.module.css';
import animation from 'styles/animation.module.css';
import './sliderHome.css';
import { useBanners } from 'hooks/useBanners';
import { EBannerAction } from 'stores/banners/types';
import { openExternalLink } from 'utils/shared';

const CasinoHome = () => {
  const { getText } = useTranslate('', '');

  const navigate = useNavigate();

  const isMobile = useZustandDeviceStore(isMobileDeviceSelector);

  const setModal = useZustandModalKitStore(
    zustandModalKitSelector.setModalInfoAction
  );

  const activeLang = useZustandLanguagesKitStore(
    languageSelectors.getActiveLanguageNameKitSelector
  );

  const banners = useBanners();

  const countryInfo = useHookFabric<CountryInfo>({
    fn: useCountryInfo,
  });

  const isAuthInfo = useHookFabric<AuthInfo>({
    fn: useAuth,
  });

  const balanceInfo = useHookFabric<BalanceInfo>({
    fn: useBalance,
  });

  const adaptedBanners = useMemo(() => {
    const { successDepositCnt = 0 } = balanceInfo || {};

    return banners.filter((banner) => {
      if (
        'countryDependencies' in banner &&
        banner.countryDependencies?.length
      ) {
        const { countryDependencies } = banner;

        if (!countryInfo?.countryId) {
          return false;
        }

        return countryDependencies.includes(countryInfo?.countryId);
      }

      if ('exceptFor' in banner && banner.exceptFor?.length) {
        if (!countryInfo?.countryId) {
          return false;
        }

        return !banner.exceptFor.includes(countryInfo?.countryId);
      }

      if ('depositDependency' in banner && banner.depositDependency) {
        const { depositDependency } = banner as any;

        return depositDependency > successDepositCnt;
      }

      return true;
    });
  }, [getText, balanceInfo, isMobile, countryInfo]);

  const handleBannerClick =
    (id: keyof typeof EBannerTypes) =>
    (e: React.MouseEvent<HTMLDivElement>) => {
      e.preventDefault();
      e.stopPropagation();
      const banner = banners.find((b) => b.id === +id);

      if (!banner) {
        alert('Not found action');

        return;
      }

      if (banner.isAuthDependency && !isAuthInfo) {
        const type = EModalTypes.SignIn;
        const title = 'header.login';

        setModal(type, {
          title,
        });

        return;
      }

      if (banner.actionType === EBannerAction.PopUp) {
        const type = EModalTypes[banner.actionValue];

        setModal(type);

        return;
      }

      if (banner.actionType === EBannerAction.Navigate) {
        navigate(banner.actionValue);

        return;
      }

      if (banner.actionType === EBannerAction.ExternalNavigate) {
        openExternalLink(banner.actionValue);

        return;
      }
    };

  return (
    <>
      {/* <div
        onClick={() => {
          useTransportControllers().sendCommand('05x', {
            registrationType: 19,
            appType: 2,
            currencyId: 586,
            countryName: 'PKR',
            countryId: 1,
            gmt: Math.floor((new Date().getTimezoneOffset() / 60) * -1), // not important,
            location: `${window.location.href}`, // not important,
            promoCode: '',
            utmMedium: '',
            utmSource: '',
            utmCampaign: '',
            language: 'em',
            clickId: '',
            // TODO dynamic
            deviceType: 1,
            requestId: 19,
          });
        }}
      >
        REg
      </div> */}
      <div className={cln(styles.wrapperCasinoHome, animation.animationFadeIn)}>
        <CasinoCategories type="buttons" withoutSubCategory withoutSearch />

        <div className={cln(styles.wrapperSlider, styles.width)}>
          <Banners
            appType={APP_TYPE}
            isAuth={Boolean(isAuthInfo)}
            isMobile={isMobile}
            banners={adaptedBanners}
            handleClick={handleBannerClick}
            language={activeLang}
          />
        </div>

        <HomeCategories />
      </div>
    </>
  );
};

export default CasinoHome;
